import cn from 'classnames';
import PlusIcon from './PlusIcon';

interface PlaylistAddButtonV2Props {
  className?: string;
  onClick: () => void;
  isDisabled: boolean;
}

const PlaylistAddButtonV2 = ({
  className,
  onClick,
  isDisabled,
}: PlaylistAddButtonV2Props) => {
  return (
    <button
      type="button"
      className={cn(
        'w-full h-12 bg-transparent flex justify-center items-center px-3',
        !isDisabled && 'hover:bg-black/10 cursor-pointer',
        isDisabled && 'cursor-not-allowed',
        className,
      )}
      onClick={onClick}
      disabled={isDisabled}
      aria-label="Add items to playlist"
    >
      <div className="w-[30px] h-[30px] bg-blue-50 rounded-full flex justify-center items-center">
        <PlusIcon size={16} className="text-blue-600" />
      </div>
    </button>
  );
};

export default PlaylistAddButtonV2;
